export const scaleColor = (color, factor = 1) => {
  if (!color || typeof color !== 'string') return color;

  const hex = color.replace('#', '');
  if (hex.length !== 6) {
    return color;
  }

  const num = parseInt(hex, 16);
  const clamp = value => Math.min(255, Math.max(0, value));
  const toHex = value => value.toString(16).padStart(2, '0');

  const r = clamp(Math.floor(((num >> 16) & 0xff) * factor));
  const g = clamp(Math.floor(((num >> 8) & 0xff) * factor));
  const b = clamp(Math.floor((num & 0xff) * factor));

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
